import { useRegisterSW } from "virtual:pwa-register/react";

export default function SWUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (registration) {
        // Check for updates every 60 minutes
        setInterval(() => registration.update(), 60 * 60 * 1000);
      }
    },
  });

  if (!needRefresh && !offlineReady) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2">
      <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-lg dark:border-gray-700 dark:bg-gray-800">
        <p className="text-sm text-gray-700 dark:text-gray-200">
          {needRefresh ? "New version available." : "App installed."}
        </p>
        {needRefresh && (
          <button
            onClick={() => updateServiceWorker()}
            className="rounded-lg bg-gray-900 dark:bg-white px-3 py-1 text-sm font-medium text-white dark:text-gray-900 hover:bg-gray-800 dark:hover:bg-gray-100"
          >
            Update
          </button>
        )}
        <button
          onClick={() => {
            setNeedRefresh(false);
            setOfflineReady(false);
          }}
          className="text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
